import Result from "./Result"
import { pluralize } from "web/services/inflector"

export default function ResultsForType({ results, type, onResultSelected }) {
  return (
    <>
      <div className="my-4 p-1 lg:hidden">
        <h2 className="text-sm font-medium text-gray-500">{pluralize(type)}</h2>
      </div>
      <div className="overflow-hidden rounded-md bg-white shadow">
        <ul className="divide-y divide-neutral-9">
          {results.map((result, index) => (
            <Result
              key={index}
              result={result}
              onResultSelected={onResultSelected}
            />
          ))}
        </ul>
      </div>
    </>
  )
}
